<template>
  <div class="empty-cell">-</div>
</template>

<style scoped>
.empty-cell {
  height: 20px;
  color: rgb(var(--v-theme-text-placeholder));
  padding-block: 2px;
}
</style>
